import { Container, Box } from "@mui/material";
import { useState } from "react";
import SwapRebalanceInfo from "./components/SwapRebalanceInfo";
import { useSelector } from "react-redux";
import { selectSwapRebalanceStrategies } from "../../../../Redux/Reducers/selectors";

const SwapStep1 = ({ setCurrentStep, contracts, setExecutionStyles }) => {
  const [existingNewArray, setExistingNewArray] = useState([]);
  const swapRebalanceStrategies = useSelector(selectSwapRebalanceStrategies);
  return (
    <Container
      disableGutters
      maxWidth="100%"
      sx={{
        marginTop: 2,
        flex: 1,
        display: "flex",
        flexDirection: "column",
        minHeight: 0,
        overflow: "hidden",
        width: "100%",
      }}
    >
      <Box sx={{ flex: 1, display: "flex", flexDirection: "column", minHeight: 0, minWidth: 0, overflow: "hidden" }}>
        <SwapRebalanceInfo
          setExistingNewArray={setExistingNewArray}
          existingNewArray={existingNewArray}
          contracts={swapRebalanceStrategies}
          setCurrentStep={setCurrentStep}
          setExecutionStyles={setExecutionStyles}
        />
      </Box>
    </Container>
  );
};

export default SwapStep1;
